export const findCookieParamsInSearchParams = (
  source: URLSearchParams
): Record<string, string> =>
  Object.fromEntries(
    Array.from(source.entries()).filter(([k]) => k.startsWith('__'))
  )
